// TODO: rename QueryParams https://en.wikipedia.org/wiki/Query_string
enum QueryParams {
    routes = 'routes',
    routeId = 'routeId',
    lineId = 'lineId',
    nodeId = 'nodeId',
    latLng = 'latLng',
    stopAreaId = 'stopAreaId',
    startDate = 'startDate',
    showItem = 'showItem',
    direction = 'direction',
    node = 'node',
    code = 'code',
    testing = 'testing',
}

export default QueryParams;
